import { t } from "@lingui/macro";
import { CircleNotch } from "@phosphor-icons/react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@reactive-resume/ui";

export const ApplyDialog = ({
  open,
  onOpenChange,
  onApply,
  isAccepting,
}: {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onApply: () => void;
  isAccepting: boolean;
}) => (
  <AlertDialog open={open} onOpenChange={onOpenChange}>
    <AlertDialogContent>
      <AlertDialogHeader>
        <AlertDialogTitle>{t`Apply Optimization`}</AlertDialogTitle>
        <AlertDialogDescription>
          {t`Are you sure you want to apply this optimization? This will update your resume with the optimized content.`}
        </AlertDialogDescription>
      </AlertDialogHeader>
      <AlertDialogFooter>
        <AlertDialogCancel disabled={isAccepting}>{t`Cancel`}</AlertDialogCancel>
        <AlertDialogAction variant="primary" onClick={onApply} disabled={isAccepting}>
          {isAccepting ? (
            <>
              <CircleNotch className="mr-2 size-4 animate-spin" />
              {t`Applying...`}
            </>
          ) : (
            t`Apply`
          )}
        </AlertDialogAction>
      </AlertDialogFooter>
    </AlertDialogContent>
  </AlertDialog>
);
